module.exports = __webpack_public_path__ + "static/img_scene3-c68786cdf2f6e24eb857c76c67915dcc.png";